export const PERMISSION_LEVELS = {
  DISABLED: 1,
  READ_ONLY: 2,
  MANAGE: 3,
}

export const ROLES = ['admin', 'technician', 'helpdesk', 'readOnly']
export const DEFAULT_ROLE = 'technician'
export const CUSTOM_ROLE = 'custom'
const MANAGED_MODULES = {
  technician: ['discover', 'engage', 'secure', 'intune', 'purview', 'teams', 'sharepoint'],
  helpdesk: ['engage'],
  readOnly: [],
}

export const getRolePermissions = (role, permissionEntities) =>
  Object.fromEntries(
    permissionEntities.map((entity) => {
      const canManage = role === 'admin' || MANAGED_MODULES[role]?.includes(entity.module_name)
      const desired = canManage ? PERMISSION_LEVELS.MANAGE : PERMISSION_LEVELS.READ_ONLY
      const level = entity.permission_options.includes(desired) ? desired : PERMISSION_LEVELS.DISABLED
      return [entity.id, level]
    }),
  )

export const getPermissionRole = (permissions, permissionEntities) => {
  if (!permissions || !permissionEntities.length || Object.keys(permissions).length !== permissionEntities.length)
    return null
  const matches = ROLES.filter((role) => {
    const expected = getRolePermissions(role, permissionEntities)
    return Object.keys(expected).every((entity) => permissions[entity] === expected[entity])
  })
  // Some presets have the same permissions when modules are unavailable, so only use an unambiguous role name.
  return matches.length === 1 ? matches[0] : null
}

export const SYSTEM_USER_ROLES = {
  OWNER: 'owner',
  SYSTEM_USER: 'system_user',
}

/** The role System Users shows for a user: Owner, the role preset their permissions match, or System user. */
export const getSystemUserRole = (user, permissionEntities) => {
  if (user.chargebee_id) return SYSTEM_USER_ROLES.OWNER
  return getPermissionRole(user.permissions, permissionEntities) || SYSTEM_USER_ROLES.SYSTEM_USER
}

export const getSystemUserRoleMessageId = (role) => {
  if (ROLES.includes(role) || role === CUSTOM_ROLE) return `COWORKERS.ROLE.${role}`
  if (role === SYSTEM_USER_ROLES.OWNER) return 'ADMINISTRATION.OWNER'
  return 'ADMINISTRATION.SYSTEMUSER'
}
